import * as React from "react";
import { AuditContextCreateForm } from "./form";

export const AuditContextCreateInitializer: React.FC = () => {
  return <AuditContextCreateForm />;
};
